import { Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const snackMessageStyles = makeStyles(({ palette, transitions, spacing }: Theme) =>
  createStyles({
    card: {
      marginLeft: 0,
      width: 350,
    },
    title: {
      flex: 1,
      fontWeight: 'bold',
    },
    expand: {
      padding: spacing(),
      transform: 'rotate(0deg)',
      transition: transitions.create('transform', {
        duration: transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    collapse: {
      padding: spacing(),
    },
    button: {
      padding: 0,
      textTransform: 'none',
    },
    date: {
      fontSize: '0.7rem',
      color: palette.primary.light,
    },
    info: {
      backgroundColor: palette.info.main,
      color: palette.info.contrastText,
    },
    warning: {
      backgroundColor: palette.warning.main,
      color: palette.warning.contrastText,
    },
    critical: {
      backgroundColor: palette.error.main,
      color: palette.error.contrastText,
    },
    success: {
      backgroundColor: palette.success.main,
      color: palette.success.contrastText,
    },
    error: {
      backgroundColor: palette.error.main,
      color: palette.error.contrastText,
    },
    acknowledgeContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    icons: {
      marginLeft: 'auto',
      display: 'flex',
    },
    closeButton: {
      textAlign: 'right',
    },
    notificationMessageContainer: {
      display: 'flex',
      flexGrow: 1,
    },
    notificationIcon: {
      display: 'flex',
      paddingTop: spacing(0.5),
      alignItems: 'center',
    },
    notificationMessage: {
      paddingTop: spacing(),
      paddingLeft: spacing(),
    },
  })
);
